'use strict';

import { getVueTemplate } from '../_imports/utils/utils.common';

const mediaLogo = {
    template: getVueTemplate('media-logo'),
    props: {
        logo: Object
    },
    computed: {
        image() {
            return this.logo ? this.logo.image : '';
        },
        imageSrc() {
            return this.image ? this.image.src : '';
        },
        imageAlt() {
            return this.image ? this.image.alt : '';
        },
        inlineStyles() {
            return this.logo ? this.logo.inlineStyles : '';
        },
        inlineStylesClass() {
            return this.logo ? this.logo.inlineStylesClass : '';
        }
    }
};

export default mediaLogo;